import React from 'react'
import UserList from './UserList'

/** Matches the User shape that UserList consumes (id is always a string here). */
interface FollowListUser {
    id: string
    name: string
    username?: string
    bio?: string
    description?: string
    md5_email?: string
    path?: string
    is_followed_by_current_user?: boolean
}

interface FollowListModalProps {
    modalParams: {
        users: FollowListUser[]
        onFollowToggle?: (userId: string, isFollowing: boolean) => void
    }
    closeModal: () => void
}

export default function FollowListModal({ modalParams, closeModal }: FollowListModalProps) {
    return (
        <UserList
            users={modalParams.users || []}
            onFollowToggle={modalParams.onFollowToggle}
            onUserClick={closeModal}
        />
    )
}
